import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const confettiData = [
  { src: "/assets/checkout/booking-confirmed/confetti-1.svg", style: { left: 23, top: 23, width: 10.3, height: 10.3 }, yOffset: -3.857, times: { opacity: [0,0.2,0.24,0.6,0.7,1], scale: [0,0.2,0.248,0.32,0.6,0.7,1] } },
  { src: "/assets/checkout/booking-confirmed/confetti-2.svg", style: { left: 195, top: 23, width: 7.7, height: 7.7 }, yOffset: 6.429, times: { opacity: [0,0.216,0.256,0.63,0.73,1], scale: [0,0.216,0.264,0.336,0.63,0.73,1] } },
  { src: "/assets/checkout/booking-confirmed/confetti-3.svg", style: { left: 23, top: 152, width: 7.7, height: 7.7 }, yOffset: -9, times: { opacity: [0,0.232,0.272,0.66,0.76,1], scale: [0,0.232,0.28,0.352,0.66,0.76,1] } },
  { src: "/assets/checkout/booking-confirmed/confetti-4.svg", style: { left: 195, top: 152, width: 10.3, height: 10.3 }, yOffset: 3.857, times: { opacity: [0,0.248,0.288,0.69,0.79,1], scale: [0,0.248,0.296,0.368,0.69,0.79,1] } },
  { src: "/assets/checkout/booking-confirmed/confetti-5.svg", style: { left: 54, top: 123, width: 5.1, height: 5.1 }, yOffset: -6.429, times: { opacity: [0,0.264,0.304,0.72,0.82,1], scale: [0,0.264,0.312,0.384,0.72,0.82,1] } },
  { src: "/assets/checkout/booking-confirmed/confetti-6.svg", style: { left: 170, top: 123, width: 5.1, height: 5.1 }, yOffset: 9, times: { opacity: [0,0.28,0.32,0.75,0.85,1], scale: [0,0.28,0.328,0.4,0.75,0.85,1] } },
  { src: "/assets/checkout/booking-confirmed/confetti-7.svg", style: { left: 54, top: 51, width: 5.1, height: 5.1 }, yOffset: -3.857, times: { opacity: [0,0.296,0.336,0.78,0.88,1], scale: [0,0.296,0.344,0.416,0.78,0.88,1] } },
  { src: "/assets/checkout/booking-confirmed/confetti-8.svg", style: { left: 170, top: 51, width: 5.1, height: 5.1 }, yOffset: 6.429, times: { opacity: [0,0.312,0.352,0.81,0.91,1], scale: [0,0.312,0.36,0.432,0.81,0.91,1] } },
];

const springEase = (t) => 1 - Math.exp(-t * 7.3635) * (Math.cos(t * 12.754) + 0.5774 * Math.sin(t * 12.754));

// Celebration illustration with animated confetti
export const CelebrationArt = () => (
  <div className="relative w-[239px] h-[180px] rounded-[31px] overflow-hidden bg-white shrink-0">
    {confettiData.map((c, i) => (
      <motion.div
        key={i}
        className="absolute"
        style={{ left: c.style.left, top: c.style.top, width: c.style.width, height: c.style.height }}
        initial={{ opacity: 0, scaleX: 0, scaleY: 0, y: 0 }}
        animate={{
          opacity: [0, 0, 0.9, 1, 0.4, 0.7],
          scaleX: [0, 0, 1.5, 1, 1.4, 0.8, 1],
          scaleY: [0, 0, 1.5, 1, 1.4, 0.8, 1],
          y: [0, c.yOffset, 0],
        }}
        transition={{
          opacity: { duration: 5, times: c.times.opacity, ease: ["linear", [0.22,1.3,0.36,1], [0.22,1.3,0.36,1], [0.45,0,0.55,1], [0.45,0,0.55,1]], repeat: Infinity },
          scaleX: { duration: 5, times: c.times.scale, ease: ["linear", springEase, springEase, [0.22,1.3,0.36,1], [0.22,1.3,0.36,1], [0.45,0,0.55,1]], repeat: Infinity },
          scaleY: { duration: 5, times: c.times.scale, ease: ["linear", springEase, springEase, [0.22,1.3,0.36,1], [0.22,1.3,0.36,1], [0.45,0,0.55,1]], repeat: Infinity },
          y: { duration: 5, times: [0, 0.5, 1], ease: [0.45,0,0.55,1], repeat: Infinity },
        }}
      >
        <img src={c.src} alt="" className="w-full h-full" />
      </motion.div>
    ))}
    {/* Main celebration image */}
    <img
      src="/assets/checkout/booking-confirmed/celebration.png"
      alt="Booking Confirmed"
      className="absolute inset-0 w-full h-full max-w-none object-cover pointer-events-none"
      style={{ left: "-5.56px", top: 0, width: "calc(100% + 11px)" }}
    />
    {/* Animated green check badge */}
    <motion.div
      className="absolute bg-[#16a34a] border-2 border-[#268750] shadow-[0px_7.7px_7.7px_rgba(0,0,0,0.08)] flex items-center justify-center rounded-[18px] w-9 h-9"
      style={{ left: "calc(50% + 68px)", top: "calc(50% + 39px)", x: "-50%", y: "-50%" }}
      initial={{ opacity: 0, scaleX: 0, scaleY: 0 }}
      animate={{
        opacity: [0, 0, 1, 1],
        scaleX: [0, 0, 1.25, 1, 1.12, 1, 1],
        scaleY: [0, 0, 1.25, 1, 1.12, 1, 1],
      }}
      transition={{
        opacity: { duration: 5, times: [0, 0.16, 0.2, 1], ease: ["linear", [0.22,1.3,0.36,1], "linear"], repeat: Infinity },
        scaleX: { duration: 5, times: [0, 0.16, 0.24, 0.3, 0.6, 0.7, 1], ease: ["linear", springEase, springEase, [0.45,0,0.55,1], springEase, "linear"], repeat: Infinity },
        scaleY: { duration: 5, times: [0, 0.16, 0.24, 0.3, 0.6, 0.7, 1], ease: ["linear", springEase, springEase, [0.45,0,0.55,1], springEase, "linear"], repeat: Infinity },
      }}
    >
      <img src="/assets/checkout/booking-confirmed/check.svg" alt="" className="w-5 h-5" />
    </motion.div>
  </div>
);

// How long the confirmation stays up before Checkout redirects to My Bookings
export const CONFIRM_REDIRECT_MS = 8000;

// Fills across the bottom of the View Booking Details button as that redirect counts down
export const RedirectTimerBar = () => (
  <motion.div
    className="absolute bottom-0 left-0 h-[2px] w-full bg-white opacity-40 origin-left"
    initial={{ scaleX: 0 }}
    animate={{ scaleX: 1 }}
    transition={{ duration: CONFIRM_REDIRECT_MS / 1000, ease: "linear" }}
  />
);

// duration reads "2 days 3 hours 0 minutes"; zero parts are dropped so a same-day trip never says "0d"
export const parseDuration = (duration) => {
  const [days = 0, hours = 0, minutes = 0] = (duration?.match(/\d+/g) || []).map(Number);
  const parts = [
    days > 0 && `${days}d`,
    hours > 0 && `${hours}h`,
    minutes > 0 && `${minutes}m`,
  ].filter(Boolean);
  const totalDays = days + hours / 24 + minutes / 1440;
  return { full: parts.join(" ") || "—", headline: totalDays > 0 ? `${totalDays.toFixed(1)} Days` : "—" };
};

// Shared by the desktop card and BookingConfirmed_mob
export const getConfirmedDetails = ({ paymentDone, carData, savedImageUrl, savedBodyType, bookingCode, payableAmount }) => {
  // paymentDone.amount is the Razorpay order amount (paise), so payableAmount wins
  const paid = payableAmount || paymentDone?.costToCustomer || paymentDone?.amount || carData?.costToCustomer;
  return {
    bookingId: bookingCode || paymentDone?.bookingCode || carData?.bookingCode || "—",
    vehicleName: carData?.vehicleName || carData?.vehicleDetails?.vehicleName || "—",
    vehicleSpecs: [
      carData?.tramissionType || carData?.vehicleDetails?.transmissionType,
      carData?.fuelType || carData?.vehicleDetails?.fuelType,
      savedBodyType || carData?.vehicleCategory || carData?.vehicleDetails?.vehicleCategory || carData?.vehicleType,
    ].filter(Boolean).join(" · ") || "",
    carImg: carData?.vehicleDetails?.imageUrl || carData?.vehicleDetails?.vehicleImgThumb || carData?.imageUrl || savedImageUrl || "/assets/logo.png",
    totalPaid: paid ? Number(paid).toLocaleString("en-IN", { minimumFractionDigits: Number.isInteger(Number(paid)) ? 0 : 2, maximumFractionDigits: 2 }) : "—",
  };
};

export const formatConfirmedDate = (dt) => {
  if (!dt) return "—";
  const d = new Date(dt);
  if (isNaN(d)) return dt;
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" }) + " · " +
    d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true }).toUpperCase();
};

export default function BookingConfirmed({ paymentDone, carData, savedImageUrl, savedBodyType, formattedStartDate, formattedEndDate, duration, cityname, pickup, drop, bookingCode, payableAmount, onViewBooking, onBackHome }) {
  const navigate = useNavigate();
  const { bookingId, vehicleName, vehicleSpecs, carImg, totalPaid } = getConfirmedDetails({ paymentDone, carData, savedImageUrl, savedBodyType, bookingCode, payableAmount });
  const { full, headline } = parseDuration(duration);

  return (
    <div className="font-['Outfit',sans-serif] bg-white border border-[#c6c6c6] flex flex-col gap-4 items-center p-8 rounded-[32px] w-full max-w-[700px] mx-auto">

      {/* Illustration + title */}
      <div className="flex flex-col gap-4 items-center">
        <CelebrationArt />
        <p className="text-[#111827] text-[32px] font-extrabold leading-tight">Booking Confirmed!</p>
      </div>

      {/* Itinerary card */}
      <div className="bg-white border border-[#e5e7eb] shadow-[0px_1px_1.5px_rgba(0,0,0,0.06),0px_4px_3px_rgba(0,0,0,0.05),0px_9px_4px_rgba(0,0,0,0.03),0px_16px_4.5px_rgba(0,0,0,0.01)] flex flex-col gap-2 p-6 rounded-[20px] w-full">

        {/* Car info row */}
        <div className="flex gap-6 items-center w-full">
          <div className="w-[188px] h-[95px] relative shrink-0 overflow-hidden">
            <img src={carImg} alt={vehicleName} className="w-full h-full object-contain scale-[1.1] origin-center" />
          </div>
          <div className="flex flex-1 items-center justify-between min-w-0 px-2">
            <div className="flex flex-col gap-1 items-start min-w-0">
              <span className="block text-[#111827] text-[19px] font-bold leading-6 text-left break-words max-w-full">{vehicleName}</span>
              {vehicleSpecs && <span className="block text-[#6b7280] text-[14px] leading-5 text-left">{vehicleSpecs}</span>}
            </div>
            <div className="bg-[#e6f4f1] border border-[#0bab7c] border-[1.5px] px-4 py-1.5 rounded-[4px] shrink-0">
              <span className="block text-[#0bab7c] text-[14px] font-bold leading-5 whitespace-nowrap">ID: #{bookingId}</span>
            </div>
          </div>
        </div>

        {/* Dashed divider */}
        <div className="w-full h-px my-1" style={{ backgroundImage: "repeating-linear-gradient(to right, #d1d5db 0, #d1d5db 6px, transparent 6px, transparent 12px)" }} />

        {/* Pickup row */}
        <div className="flex items-start justify-between gap-4 w-full">
          <div className="flex flex-col gap-1 items-start flex-1 min-w-0">
            <span className="block text-[#0bab7c] text-[13px] font-bold uppercase tracking-wide leading-5 text-left">Pickup</span>
            <span className="block text-[#111827] text-[16px] font-bold leading-6 text-left break-words max-w-full">{pickup || "Hub Location"}</span>
            {cityname && <span className="block text-[#6b7280] text-[12px] leading-4 text-left">{cityname}</span>}
          </div>
          <span className="block text-[#111827] text-[16px] font-semibold leading-6 whitespace-nowrap shrink-0">{formatConfirmedDate(formattedStartDate)}</span>
        </div>

        {/* Duration badge */}
        <div className="flex items-center w-full">
          <div className="flex-1 h-px" style={{ backgroundImage: "url('/assets/checkout/booking-confirmed/seam.svg')", backgroundRepeat: "repeat-x", backgroundSize: "auto 100%" }} />
          <div className="bg-[rgba(128,128,254,0.64)] px-2 py-0.5 rounded-[8px] mx-2 min-w-[82px] flex items-center justify-center">
            <span className="block text-[#000646] text-[13px] font-bold leading-5 whitespace-nowrap">{full}</span>
          </div>
          <div className="flex-1 h-px" style={{ backgroundImage: "url('/assets/checkout/booking-confirmed/seam.svg')", backgroundRepeat: "repeat-x", backgroundSize: "auto 100%" }} />
        </div>

        {/* Drop off row */}
        <div className="flex items-start justify-between gap-4 w-full">
          <div className="flex flex-col gap-1 items-start flex-1 min-w-0">
            <span className="block text-[#ef4444] text-[13px] font-bold uppercase tracking-wide leading-5 text-left">Drop Off</span>
            <span className="block text-[#111827] text-[16px] font-bold leading-6 text-left break-words max-w-full">{drop || "Hub Location"}</span>
            {cityname && <span className="block text-[#6b7280] text-[12px] leading-4 text-left">{cityname}</span>}
          </div>
          <span className="block text-[#111827] text-[16px] font-semibold leading-6 whitespace-nowrap shrink-0">{formatConfirmedDate(formattedEndDate)}</span>
        </div>

        {/* Thin divider */}
        <div className="w-full border-t border-[#e5e7eb] my-1" />

        {/* Footer: days + price */}
        <div className="flex items-center justify-between w-full">
          <div className="bg-[rgba(128,128,254,0.1)] px-2.5 py-1 rounded-[6px]">
            <span className="block text-[#0bab7c] text-[18px] font-bold leading-6 whitespace-nowrap">{headline}</span>
          </div>
          <div className="flex flex-col gap-0.5 items-end">
            <span className="block text-[#6b7280] text-[12px] leading-4">Total Amount Paid</span>
            <span className="block text-[#0bab7c] text-[24px] font-extrabold leading-7 whitespace-nowrap">₹{totalPaid}</span>
          </div>
        </div>
      </div>

      {/* Action buttons */}
      <div className="flex gap-3.5 w-full">
        <button
          onClick={onViewBooking || (() => navigate("/bookings"))}
          className="relative flex-1 h-[54px] flex items-center justify-center rounded-[12px] text-white text-[16px] font-semibold overflow-hidden"
          style={{ background: "linear-gradient(9.68deg, #9e85dd 25%, #7b39ec 59.86%)" }}
        >
          View Booking Details
          <RedirectTimerBar />
        </button>
        <button
          onClick={onBackHome || (() => navigate("/"))}
          className="flex-1 h-[52px] flex items-center justify-center rounded-[12px] bg-white border-[1.5px] border-[#0bab7c] text-[#0bab7c] text-[16px] font-bold"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
